import { Flex } from 'antd';
import React from 'react';

import { WIDTH_CARD_TASK_BIG, WIDTH_CARD_TASK_MEDIUM } from '../const';
import { TaskPositionType } from '../types';
import CalendarTaskBodyBadge from './calendarTaskBodyBadge';
import CalendarTaskBodyStatusesLine from './calendarTaskBodyStatusesLine';

interface ICalendarTaskBodyThirdLine {
    task: TaskPositionType;
    widthTaskBody: number;
}

const CalendarTaskBodyThirdLine: React.FC<ICalendarTaskBodyThirdLine> = ({ task, widthTaskBody }) => {
    const badge = <CalendarTaskBodyBadge task={task} widthTaskBody={widthTaskBody} />;

    const getPadding = () => {
        if (task.height === 5 && widthTaskBody > WIDTH_CARD_TASK_MEDIUM) {
            return '3px 0';
        }

        if (task.height > 2) {
            return '5px 0';
        }

        return 0;
    };

    return (
        <>
            {task.height > 1 && (
                <Flex gap={20} align={'center'} style={{ padding: getPadding() }}>
                    <CalendarTaskBodyStatusesLine task={task} widthTaskBody={widthTaskBody} />
                    {widthTaskBody >= WIDTH_CARD_TASK_BIG && badge}
                </Flex>
            )}
        </>
    );
};

export default CalendarTaskBodyThirdLine;
